import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Reset link generated (check server logs in demo mode).");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="We'll send a reset link to your email."
      footer={<><Link to="/login" className="text-primary hover:underline font-medium">Back to sign in</Link></>}
    >
      {sent ? (
        <div className="rounded-md border border-border bg-card p-6 text-center space-y-3" data-testid="forgot-success">
          <MailCheck className="h-10 w-10 mx-auto text-success" />
          <p className="text-sm text-muted-foreground">
            If an account exists for <span className="text-foreground font-medium">{email}</span>, a reset link has been generated.
          </p>
          <Link to="/reset-password" className="text-sm text-primary hover:underline">Have a token? Reset here</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
